import React from 'react';
import './Quote.css';

const Quote = () => (
  <section className="section section-quote">
    <h2 className="section-heading">
      Mathematics s not about numbers, equations, computations, or
      algorithms; It is about understanding - William Paul Thurston.
    </h2>
  </section>
);

export default Quote;
